module.exports = __webpack_public_path__ + "assets/6f5262b72e46e844b42682748e7765d7.png";